import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contablegastoComboReducer(state= initialState.contablegastoCombo, action){
	switch(action.type){
		case types.GET_CONTABLEGASTOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}